import React, { useEffect, useState, lazy } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  const [spotsTaken, setSpotsTaken] = useState(71);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-165" data-mp="21pczpx2147sv">
      <div className="bg-brand-purpleDark text-brand-surface font-display font-semibold text-2xl md:text-4xl rounded-sm px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center tabular-nums border border-brand-gold/30" data-id="element-166" data-mp="1wtp9debt98ls">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-167" data-mp="25l3qijjzvz26">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-168" data-mp="2alhwzx5y70y3">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border border-brand-goldDark/25" data-id="element-169" data-mp="2fjt7ma42hfhd">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-170" data-mp="2ki4imo63lw16">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-purple shrink-0" data-id="element-171" data-mp="2kg9tsyrphjrt" />
          <h3 className="font-display font-semibold uppercase tracking-[0.14em] text-[13px] md:text-lg text-brand-burgundy text-center" data-id="element-172" data-mp="2p9mi17sh3ok1">
            Precio de lanzamiento — cierra en
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-173" data-mp="2y7odz8xcnr0g">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-174" data-mp="339dqyu44uer6" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-175" data-mp="136ctyk1o1mtk">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-176" data-mp="y8b33cy00j7j" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-177" data-mp="y5gjtoqq14fp">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-178" data-mp="185pjxdnu3a0d" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-brand-surfaceLight border border-brand-goldDark/25 rounded-xl px-4 py-3 mb-6" data-id="element-179" data-mp="184edt76x1q63">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-burgundy shrink-0" data-id="element-180" data-mp="1hvsh7q1zna4i" />
          <p className="text-sm md:text-base font-semibold text-brand-text text-center" data-id="element-181" data-mp="1vv1og087utwc">
            Después sube $25.000 ARS.{' '}
            <span className="text-brand-purple" data-id="element-182" data-mp="1qx8ldg27mg0a">No vuelve.</span>
          </p>
        </div>

        <div className="bg-brand-surface/70 rounded-2xl p-4 md:p-5 border border-brand-goldDark/20" data-id="element-183" data-mp="1ghae6eehwlx">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-184" data-mp="3soln5w8vs7s4">
            <div className="flex items-center gap-2" data-id="element-185" data-mp="286kj2w6w74hc">
              <span className="inline-flex h-2 w-2 rounded-full bg-brand-burgundy" data-id="element-186" data-mp="287vqd5zjqud7"></span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-187" data-mp="2d6p511qkkrey">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-188" data-mp="23dhxba8cwzbp">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-purple/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-189" data-mp="1uenwt8rwnosv">
            <div className="bg-brand-purple h-2.5 rounded-full transition-[width] duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-190" data-mp="1fhdmi2r00oyq" />
          </div>
          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-191" data-mp="39w6gjxc8h7ok">
            <strong className="text-brand-purple" data-id="element-192" data-mp="3euhn9z78f22k">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomo1Features = ['✅ Psicología del orden clínico', '✅ Protocolo de sellado áurico profesional', '✅ Estructura de la sesión élite — KĀI / YÒNG / HÉ', '✅ Higiene energética del espacio entre pacientes', '✅ Ergonomía energética del terapeuta', '✅ Diagnóstico visual veloz del estado del paciente', '✅ El terapeuta como ser completo', '✅ Mapa del año terapéutico'];
const tomo2Features = ['✅ Biblioteca completa de series terapéuticas', '✅ Chi Kung clasificado por sistemas orgánicos', '✅ Protocolos por patología específica', '✅ Gestión de crisis energéticas en sesión', '✅ Tareas de práctica para el paciente en casa', '✅ Series adaptadas por nivel del paciente'];
const tomo3Features = ['✅ Planificación por estaciones energéticas', '✅ Agenda completa de 52 semanas', '✅ Plantillas de seguimiento clínico del paciente', '✅ Organización profesional del consultorio', '✅ Metas terapéuticas por trimestre', '✅ Registro de evolución por paciente'];
const tomos = [{
  n: 'I',
  cover: 'https://cdn.magicpatterns.com/uploads/jynD7f8T5XDD9UyyetqbjW/Captura_de_pantalla_2026-07-09_005238.png',
  title: 'Fundamentos Operativos y Blindaje del Terapeuta',
  subtitle: 'El sistema operativo completo del terapeuta profesional.',
  accent: 'text-brand-burgundy',
  features: tomo1Features
}, {
  n: 'II',
  cover: 'https://cdn.magicpatterns.com/uploads/p8fdYg1hTd5WZcY6GboRPG/Captura_de_pantalla_2026-07-09_005317.png',
  title: 'Vademécum de Sesiones y Tratamientos',
  subtitle: 'La biblioteca clínica de Chi Kung más completa en español.',
  accent: 'text-brand-amber',
  features: tomo2Features
}, {
  n: 'III',
  cover: 'https://cdn.magicpatterns.com/uploads/qA8w8WpWd7T6Q58rhShCHT/Captura_de_pantalla_2026-07-09_005335.png',
  title: 'Planificador Anual 365',
  subtitle: 'Planificación estratégica de 52 semanas por estaciones.',
  accent: 'text-brand-greenMoss',
  features: tomo3Features
}];
type Bonus = {
  n: string;
  cover?: string;
  title: string;
  price: string;
};
const bonuses: Bonus[] = [{
  n: '01',
  cover: 'https://cdn.magicpatterns.com/uploads/izXiz8qHHHmhcF7NzwFYpE/Portada_bono_1.png',
  title: 'Cuaderno de Planificación Imprimible',
  price: '$12.000'
}, {
  n: '02',
  cover: 'https://cdn.magicpatterns.com/uploads/soQDKuVirwVNDfDTRKho9o/Portada_bono_2.png',
  title: '52 Guiones de Visualización',
  price: '$15.000'
}, {
  n: '03',
  cover: 'https://cdn.magicpatterns.com/uploads/mj6k5ncoTuy7xdPtbBKVa3/Portada_bono_3.png',
  title: 'Kit de Gráficos para el Consultorio',
  price: '$10.000'
}, {
  n: '04',
  cover: 'https://cdn.magicpatterns.com/uploads/fdQnLkSDXyfusoJCeSWn4K/Portada_bono_4.png',
  title: 'Protocolo de Chi Kung Adaptado',
  price: '$12.000'
}, {
  n: '05',
  cover: 'https://cdn.magicpatterns.com/uploads/eM4GmmLyaHVhBFXDtCHhqf/Portada_bono_5.png',
  title: 'Audio-Entrenamiento "Limpieza Rápida"',
  price: '$10.000'
}, {
  n: '06',
  cover: 'https://cdn.magicpatterns.com/uploads/igdVVLtCTu8WRsKKBwXCjE/Portada_bono_6.png',
  title: 'Curaduría de Sonidos Sanadores',
  price: '$10.000'
}];
export const PackContents = () => {
  return <Section id="method" className="relative" data-id="element-193" data-mp="h5vs9zrmgwex">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-194" data-mp="h6xd2vyfwx9u">
        <div className="absolute top-10 right-[4%] hidden select-none font-hanzi text-[120px] font-light leading-none text-brand-goldDark/[0.07] lg:block" data-id="element-195" data-mp="8dtuk98xtu8c">
          法
        </div>
      </div>
      <div className="mx-auto mb-16 max-w-3xl px-4 relative" data-id="element-196" data-mp="cd2p3gbsxw4y">
        <div className="mb-5 flex flex-col items-center gap-2 text-center" data-id="element-197" data-mp="10485pxpkgsgb">
          <h3 className="font-serif text-2xl md:text-3xl font-semibold italic text-brand-burgundy" data-id="element-198" data-mp="14vzt5zdfei28">
            Mirá el material por dentro
          </h3>
          <div aria-hidden="true" className="ink-rule w-12 opacity-60" data-id="element-199" data-mp="g6wxmitnxyge" />
        </div>
        <div className="relative overflow-hidden rounded-2xl border border-brand-goldDark/20 bg-brand-surface shadow-sm" data-id="element-200" data-mp="bd2crc2bndfq">
          <video src="https://cdn.magicpatterns.com/uploads/hjPHvRJ5yMp5bk6yumZprG/Scroll_Chi_Kung_Magic_Partners_Optimizado.mp4" autoPlay loop muted playsInline className="w-full h-auto object-cover" data-id="element-201" data-mp="1g7k39sqc79d" />
        </div>
      </div>

      <div className="text-center mb-8 relative" data-id="element-202" data-mp="p5id253u8xcy">
        <h2 className="font-serif text-3xl md:text-5xl font-semibold mb-3 leading-tight text-brand-burgundy" data-id="element-203" data-mp="p478w46hdnlb">
          3 Tomos Principales + 6 Bonus Estratégicos
        </h2>
        <p className="font-serif italic text-brand-textLight/80 text-lg md:text-xl" data-id="element-204" data-mp="39x2ahpscbz6k">
          Más de 190 páginas — todo resuelto.
        </p>
      </div>

      <div className="max-w-4xl mx-auto mb-10" data-id="element-205" data-mp="34z93iuj7r158">
        <div className="grid grid-cols-1 gap-4 md:gap-5" data-id="element-206" data-mp="1kfx3uhxxnwef">
          {tomos.map(tomo => <div key={tomo.n} className="glass-panel rounded-xl overflow-hidden border-brand-goldDark/20 flex flex-row items-start p-4 md:p-6 text-left" data-id="element-207" data-mp="1pf05dsepfkhn">
              <div className="relative w-24 md:w-32 shrink-0 rounded-md overflow-hidden shadow-md ring-1 ring-brand-goldDark/20 mr-4 md:mr-6" data-id="element-208" data-mp="1z4thqvmo83my">
                <img src={tomo.cover} alt={`Tomo ${tomo.n} — ${tomo.title}`} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-209" data-mp="244xnbqm1jdye" />
              </div>
              <div className="flex-1 min-w-0 py-1" data-id="element-210" data-mp="2i2w0isoml4cb">
                <div className="mb-3" data-id="element-211" data-mp="2i0jiygms4vzs">
                  <span className={`inline-block ${tomo.accent} font-display text-[10px] md:text-[11px] font-semibold uppercase tracking-[0.2em] mb-1`} data-id="element-212" data-mp="iq1rao9356ga">
                    Tomo {tomo.n}
                  </span>
                  <h4 className={`font-serif text-lg md:text-xl font-semibold leading-tight ${tomo.accent}`} data-id="element-213" data-mp="ra8z0rq2thgo">
                    {tomo.title}
                  </h4>
                </div>
                <ul className="space-y-1.5 text-[12px] md:text-[13px] text-brand-text w-full" data-id="element-214" data-mp="157xko1rywsms">
                  {tomo.features.map((f, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-215" data-mp="1a67hegtcc1ai" data-mpi={i}>
                      <span className={`${tomo.accent} shrink-0 font-serif font-bold`} data-id="element-216" data-mp="1f5jz6n5cui68">
                        ·
                      </span>
                      <span className="leading-snug" data-id="element-217" data-mp="1jxllz305frai">{f.replace('✅ ', '')}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mb-6 mt-10" data-id="element-218" data-mp="1svnhx450ztqx">
        <h3 className="text-base md:text-xl font-display font-semibold uppercase tracking-[0.14em] text-brand-burgundy" data-id="element-219" data-mp="1xvtbipuuvqbn">
          6 Bonus estratégicos —{' '}
          <span className="text-brand-goldDark" data-id="element-220" data-mp="3dfiv8l8xb0py">siempre incluidos</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-3xl grid-cols-3 gap-2.5 sm:grid-cols-6 md:gap-3" data-id="element-221" data-mp="3dhvlrmsqyjem">
        {bonuses.map(bonus => <div key={bonus.n} className="flex flex-col" data-id="element-222" data-mp="34fdx71pmdeog">
            <div className="relative rounded-lg overflow-hidden ring-1 ring-brand-goldDark/20 bg-brand-surface aspect-[3/4]" data-id="element-223" data-mp="34gxi55m80dwk">
              {bonus.cover ? <img src={bonus.cover} alt={`Bono ${bonus.n} — ${bonus.title}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-224" data-mp="z6xt7e8m3lh" /> : <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-2 bg-brand-surfaceLight" data-id="element-225" data-mp="onq4jihn28bg">
                  <span className="text-[8px] font-bold tracking-widest text-brand-goldDark mb-1" data-id="element-226" data-mp="jvyo40s75iz1">
                    BONO {bonus.n}
                  </span>
                  <span className="font-serif font-bold text-brand-burgundy text-[10px] leading-tight" data-id="element-227" data-mp="17sbqmiokshru">
                    {bonus.title}
                  </span>
                </div>}
              <span className="absolute top-0 right-0 bg-brand-gold text-brand-purpleDark text-[8px] md:text-[9px] font-bold px-1.5 py-0.5 rounded-bl-md" data-id="element-228" data-mp="y2iffisci4o4">
                GRATIS
              </span>
            </div>
            <p className="text-center text-[9px] md:text-[10px] text-brand-muted mt-1" data-id="element-229" data-mp="p1k6cm31v6yo">
              <span className="line-through" data-id="element-230" data-mp="b22iqa1hpzqw">{bonus.price}</span>
              <span className="ml-1 font-bold text-brand-goldDark" data-id="element-231" data-mp="b3vmnhkpy5v7">GRATIS</span>
            </p>
          </div>)}
      </div>

      <div className="text-center mt-6" data-id="element-232" data-mp="25g3ntcnmvizf">
        <div className="inline-block glass-panel px-5 py-2.5 rounded-full border-brand-goldDark/25" data-id="element-233" data-mp="25het5gwq8ysn">
          <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-234" data-mp="29gdvquuzkjgx">
            Valor total bonos{' '}
            <span className="line-through text-brand-text/50" data-id="element-235" data-mp="3u095y33l7abq">$69.000</span>{' '}
            <span className="text-brand-purple font-bold" data-id="element-236" data-mp="3pz5s1m53nod5">
              → GRATIS con tu Mega Pack
            </span>
          </p>
        </div>
      </div>
    </Section>;
};
export const MethodOverview = () => <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-237" data-mp="2sn0q617yzsr">
    <LaunchUrgency data-id="element-238" data-mp="hht4m7b05e6z" />
    <Pricing data-id="element-239" data-mp="hh9kql1skfqb" />
  </div>;